import type { ActivationFlowDefinition } from "../types";

export const firstExportTranscriptFlow: ActivationFlowDefinition = {
    id: "first_export_transcript",
    title: "Edit by Transcript Workflow",
    steps: [
        {
            id: "intro_editor",
            title: "Welcome to the editor",
            target: "[data-tour='editor-workspace-area']",
            placement: "center",
            spotlightPadding: 14,
            content:
                "In this quick demo, we'll edit a recording by editing the transcript.",
            advance: {
                type: "manual",
            },
        },
        {
            id: "delete_transcript_section",
            title: "Delete a section",
            target: "[data-tour='transcript-panel']",
            placement: "right",
            spotlightPadding: 12,
            content:
                "This is the transcript. Highlight a section and press Delete to remove it. Or click strikethrough on the toolbar.",
            advance: {
                type: "condition",
                condition: "script_has_cut",
            },
        },
        {
            id: "assign_speakers",
            title: "Assign speaker names",
            target: "[data-tour='transcript-panel']",
            placement: "right",
            spotlightPadding: 12,
            content:
                "Click on the speaker labels in the transcript to assign names (e.g. Speaker A, Speaker B). When you're done, click Next.",
            advance: {
                type: "manual",
            },
        },
        {
            id: "open_export_menu",
            title: "Export your composition",
            target: "[data-tour='editor-export-button']",
            placement: "bottom",
            content: "Click Export to open export settings.",
            advance: {
                type: "click",
                selector: "[data-tour='editor-export-button']",
            },
        },
        {
            id: "start_export",
            title: "Start export",
            target: "[data-tour='export-card-submit']",
            placement: "left",
            content: "Click Export to render your first episode.",
            advance: {
                type: "click",
                selector: "[data-tour='export-card-submit']",
            },
        },
    ],
};
